'use client';

import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { useTranslations } from 'next-intl';
import { FeatureComparisonTable } from '@/components/page-builder/global/pricingV1/featureComparison/FeatureComparisonTable';
import { PlanTabs } from '@/components/page-builder/global/pricingV1/shared/PlanTabs';
import Heading from '@/components/typography/Heading';
import { FEATURE_COMPARISON_ANCHOR_ID } from '@/constants/pricing.constants';
import { cn } from '@/lib/styles';
import { PRICING_TEST_IDS } from '@/lib/test-ids';
export function FeatureComparison(t0) {
  const $ = _c(22);
  const {
    data,
    yearly,
    currentTab,
    setCurrentTab
  } = t0;
  const t = useTranslations("Pricing");
  let t1;
  if ($[0] !== t) {
    t1 = t("compareFeatures");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Heading tag="h2" fontSize="displayMedium" className="text-center w-full text-neutral-light-100">{t1}</Heading>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== data || $[5] !== yearly) {
    t3 = item => <FeatureComparisonTable data={data} currentTab={item?.title} yearly={yearly} />;
    $[4] = data;
    $[5] = yearly;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== currentTab || $[8] !== data || $[9] !== setCurrentTab || $[10] !== t3) {
    t4 = <PlanTabs currentTab={currentTab} setCurrentTab={setCurrentTab} data={data} renderContent={t3} className="w-full py-5.5 lg:hidden" />;
    $[7] = currentTab;
    $[8] = data;
    $[9] = setCurrentTab;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = !yearly && "max-w-200 mx-auto";
  let t6;
  if ($[12] !== t5) {
    t6 = cn("hidden lg:block lg:pt-7.25", t5);
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== data || $[15] !== t6 || $[16] !== yearly) {
    t7 = <FeatureComparisonTable data={data} yearly={yearly} className={t6} />;
    $[14] = data;
    $[15] = t6;
    $[16] = yearly;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t2 || $[19] !== t4 || $[20] !== t7) {
    t8 = <div id={FEATURE_COMPARISON_ANCHOR_ID} className="mt-0 lg:mt-10 relative bg-brand-black" data-test-id={PRICING_TEST_IDS.COMPARE}>{t2}{t4}{t7}</div>;
    $[18] = t2;
    $[19] = t4;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}